import React from 'react'

function Footer() {
  return (
    <footer class="text-center py-3 mt-5 shadow-lg">
        <div class="container">
            <p class="mb-3">
            <strong>&copy; 2026 JAWAHARLAL NEHRU UNIVERSITY, NEW DELHI. All rights reserved.</strong>
            </p>
        </div>
        </footer>

  )
}

export default Footer